import { InjectionToken, Provider } from '@angular/core';

import { Environment } from '@personalized-supplements-v2/environments/env';
import { environment } from '@personalized-supplements-v2/environments/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');

export const environmentProvider: Provider = {
  provide: ENVIRONMENT,
  useValue: environment,
};
